import React, { useEffect, useReducer} from 'react';
import {BrowserRouter,Routes, Route,Switch, useLocation} from 'react-router-dom'
import {
  CSSTransition,
  TransitionGroup,
} from 'react-transition-group';

import HomePage from '../components/HomePage';
import Firm from '../components/Firm';
import Boardofdirectors from '../components/Boardofdirectors';
import People from '../components/People';
import Credit from '../components/Credit';
import Investment from '../components/Investment';
import Realestate from '../components/Realestate';
import Career from '../components/Career';
import Advisory from '../components/Advisory';
import Initiative from '../components/Initiative';


const AppRouter = () => {

  return (
    
  <BrowserRouter>
  <div>



    <Route render={({location}) => (
    <TransitionGroup>
    <CSSTransition key={location.key} timeout={450} classNames="fade">
         <Switch  location={location}>
  <Route path="/" component={HomePage} exact={true} />
  <Route path="/firm" component={Firm} exact={true} />
  <Route path="/credit" component={Credit} exact={true} />
  <Route path="/career" component={Career} exact={true} />
  <Route path="/advisory" component={Advisory} exact={true} />
  <Route path="/realestate" component={Realestate} exact={true} />
  <Route path="/investment" component={Investment} exact={true} />
  <Route path="/boardofdirectors" component={Boardofdirectors} exact={true} />
  <Route path="/ourpeople" component={People} exact={true} />
  <Route path="/initiative" component={Initiative} exact={true} />


  {/* <Route path="/dashboard" component={dashboardPage  } /> */}


     </Switch>
     </CSSTransition>
  </TransitionGroup>
  )} />
      </div>
</BrowserRouter>

)

};

export default AppRouter;
